import {request} from '@/helpers/apiClient'
import {FILE_UPLOAD_CONFIG} from '@/utils/constants/apiConfig/fileUploadConfig'
import {Constants} from '@/utils/constants/commonConstants'
import {template} from 'lodash'

export const getFileVerification = async (formData, uploadFor, isTemplateUpload) => {
  /* We can add switch case to handle different uploadFor cases */
  if (uploadFor && uploadFor === Constants.SalesTargetMedia) {
    return request(FILE_UPLOAD_CONFIG.UPLOAD_SALES_TARGET_CONTENT, {data: formData}, 'type=' + Constants.Public)
  }
  if (uploadFor && uploadFor === Constants.BulkModifiers) {
    return request(FILE_UPLOAD_CONFIG.UPLOAD_BULK_MODIFIER_FILE, {body: formData})
  }
  if (isTemplateUpload && uploadFor !== Constants.bulkUploadPromotions) {
    const queryParams = `templateType=${uploadFor}&fileName=${formData?.file.name}`
    return request(FILE_UPLOAD_CONFIG.TEMPLATE_UPLOAD, '', queryParams)
  }
  if (uploadFor && uploadFor === Constants.bulkUploadPromotions) {
    return request(FILE_UPLOAD_CONFIG.UPLOAD_BULK_PROMOTION_FILE, {file: formData})
  }
}
